module.exports = __webpack_public_path__ + "media/src/images/site-top/illust3-fca1e893ec3916d641bf56ff33a012f9.png";